'use strict'

let watermark = {}

let setWatermark = (str) => {

  let  id = 'Watermark238.4164.123.412.415'
  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id))
  }

  let can = document.createElement('canvas')
  can.width = 500
  can.height = 300

  let cans = can.getContext('2d')
  cans.rotate(-20 * Math.PI / 180)
  cans.font = '30px Vedana'
  cans.fillStyle = 'rgba(200, 200, 200, 0.20)'
  cans.textAlign = 'left'
  cans.textBaseline = 'Middle'
  cans.fillText(str, can.width / 3, can.height / 2)

  let div = document.createElement('div')
  div.id = id
  div.style.pointerEvents = 'none'
  div.style.top = '80px'
  div.style.left = '200px'
  div.style.position = 'fixed'
  div.style.zIndex = '100000'
  div.style.width = document.documentElement.clientWidth - 100 + 'px'
  div.style.height = document.documentElement.clientHeight - 100 + 'px'
  div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat'
  document.body.appendChild(div)
  return id
}

// 该方法只允许调用一次
watermark.set = (str,self) => {
    let id = setWatermark(str)
  //需要在store里添加变量watermarkStatus 值为false,在登录和APP首页注册时将值变为true
    var interval = setInterval(() => {
      if(!self.$store.state.watermarkStatus){
        clearInterval(interval)
        document.body.removeChild(document.getElementById(id))
      }
      if (document.getElementById(id) === null &&self.$store.state.watermarkStatus) {
        console.log('asdasdasd true')
        id = setWatermark(str)
      }
    }, 500)
    window.onresize = () => {
      setWatermark(str)
    }
}

export default watermark



// WEBPACK FOOTER //
// ./src/watermark.js